<template>
    <div class="content">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'Content'
}
</script>

<style>
    .content {
        z-index: 1;
        /* background-color: rgba(141, 252, 252, 0.15); */
        margin: 0;
    }
</style>